import { render, staticRenderFns } from "./my-form.vue?vue&type=template&id=1c63f502&scoped=true&"
import script from "./my-form.vue?vue&type=script&lang=js&"
export * from "./my-form.vue?vue&type=script&lang=js&"
import style0 from "./my-form.vue?vue&type=style&index=0&id=1c63f502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63f502",
  null
  
)

export default component.exports